import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BudgetCreateDto,
  BudgetDto,
  BudgetListRequestDto,
  BudgetSuggestionsRequestDto,
  ChangeBudgetsPeriodDto,
  ChangeBudgetsPeriodResult,
  UpdateBudgetDto,
} from '@epicuro-next/models/seller-tools';

import { BUDGET_API_TOKEN } from '../token';

@Injectable()
export class BudgetsService {
  private api = inject(BUDGET_API_TOKEN);
  private http = inject(HttpClient);

  public getBudgets(filters: BudgetListRequestDto) {
    return this.http.post<BudgetDto[]>(`${this.api}/list`, filters);
  }

  public createBudget(budgetCreate: BudgetCreateDto) {
    return this.http.post<BudgetDto>(this.api, budgetCreate);
  }

  public updateBudget(budgetId: number, budgetUpdate: UpdateBudgetDto) {
    return this.http.put<void>(`${this.api}/${budgetId}`, budgetUpdate);
  }

  public deleteBudgets(budgetIds: number[]) {
    return this.http.delete<void>(`${this.api}`, {
      body: budgetIds,
    });
  }

  public changePeriod(changePeriod: ChangeBudgetsPeriodDto) {
    return this.http.post<ChangeBudgetsPeriodResult>(
      `${this.api}/change-period`,
      changePeriod,
    );
  }

  public getSuggestions(requests: BudgetSuggestionsRequestDto) {
    return this.http.post<BudgetDto[]>(`${this.api}/suggestions`, requests);
  }

  public rename(budgetId: number, name: string) {
    return this.http.put<void>(`${this.api}/${budgetId}/rename`, { name });
  }
}
